import { Checkbox } from '@global-engineering-shared/gweb-material-ui';

import useStyles from 'components/Table/TableCheckBox/TableCheckBox.styles';
import { usePaginatedItemsContext } from 'context/PaginatedItems/context/PaginatedItemsProvider';
import { PaginatedItems } from 'context/PaginatedItems/types/PaginatedItems';
import { useSelectedEntitiesContext } from 'context/SelectedEntities/SelectedEntitiesProvider';
import { TTableEntity } from 'types/tableEntityType';

type TableCheckBoxProps = {
  entityId: string;
};

const TableCheckBox = ({ entityId }: TableCheckBoxProps) => {
  const classes = useStyles();
  const { isEntitySelected, updateSelectedEntities } = useSelectedEntitiesContext();
  const { items } = usePaginatedItemsContext() as PaginatedItems<TTableEntity>;

  return (
    <Checkbox
      checked={isEntitySelected(entityId)}
      onClick={(event) => {
        event.stopPropagation();
      }}
      onChange={() => updateSelectedEntities(entityId, items)}
      className={classes.checkbox}
    />
  );
};

export default TableCheckBox;
